module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = G/5Q
// module chunks = 10